import React, { useState, useEffect, useContext } from "react";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";
import {
  BaseButtons,
  LoadingPopUp,
  TextInputField,
  ToastNotification,
} from "../common-components";
import { AnimatedIcon } from "./components";
import { AuthContext } from "../../context/auth-context";
import { useNavigate } from "react-router-dom";

const AgencyDisplay = () => {
  const { width, height } = useWindowDimensions();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [animate1, setAnimate1] = useState(false);
  const [animate2, setAnimate2] = useState(false);
  const [animate3, setAnimate3] = useState(false);
  const [animate4, setAnimate4] = useState(false);
  const [animate5, setAnimate5] = useState(false);
  const [animate6, setAnimate6] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [toastPop, setToastPop] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState(false);
  const LoginHandler = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/agencyLogin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            email: email,
            password: password,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.userId) {
        auth.login();
        auth.customerLoadData({
          cellNumber: respnseData.cellNumber,
          dateCreated: respnseData.dateCreated,
          email: respnseData.email,
          firstName: respnseData.firstName,

          lastName: respnseData.lastName,
          companyId: respnseData.companyId,
          permissons: respnseData.permissions,
          userId: respnseData.userId,

          lastOn: respnseData.lastOn,
          type: respnseData.type,
          team: respnseData.team,
        });

        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("Log-in successful");
        setLoading(false);

        if (respnseData.type === "ADMIN") {
          navigate("/agency-admin");
        } else {
          navigate("/agency");
        }

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to Login because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);

        setTimeout(() => {
          setPopUpTitle("");
          setMessage("");
        }, 3000);
      }, 5000);
    }
  }, [toastPop]);
  return (
    <div
      style={{
        height: height,
        width: width,
        // backgroundColor: "#489FB5",
        backgroundColor: colors.white,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <img
        alt="logo"
        src={require("../../images/base-logo-desgns/driverfrinedlogo4.png")}
        style={{ height: 200, marginBottom: 0, zIndex: 3 }}
      />
      <div
        style={{
          //   backgroundColor: colors.secondaryDarkBlue,
          backgroundColor: "#FFFFFF50",
          //   borderRadius: 8,
          //   padding: 20,
          width: 580,
          //   WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 3,
        }}
      >
        <div
          style={{
            // marginTop: 20,
            marginBottom: 20,
            width: "100%",
            textAlign: "center",
            fontSize: 24,
            fontWeight: "bold",
            color: colors.secondaryDarkBlue,
          }}
        >
          AGENCY LOGIN
        </div>
        <TextInputField
          labelTitle={"USERNAME"}
          mini={true}
          width={"100%"}
          size={"90%"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextInputField
          labelTitle={"PASSWORD"}
          mini={true}
          width={"100%"}
          size={"90%"}
          value={password}
          type={"password"}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div
          style={{
            width: "95%",

            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <BaseButtons
            label={"FORGOT PASSWORD"}
            borderRadius={8}
            backgroundColor={colors.secondaryDarkBlue}
            width={180}
          />
        </div>
        <div
          style={{
            width: "95%",

            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: 60,
          }}
        >
          <BaseButtons
            label={"LOGIN"}
            borderRadius={8}
            backgroundColor={colors.primaryBlue}
            width={"100%"}
            color={colors.white}
            onClick={() => LoginHandler()}
          />
        </div>
      </div>
      {/* <div style={{ flex: 0.2, position: "absolute", width: "100%", top: 0 }}>
        <AnimatedIcon
          image={require("../../images/material-icon/blueMore.png")}
          animate={animate1}
          setAnimate={setAnimate1}
          timer={3500}
          timerInSecs={"3.5s"}
        />
      </div>
      <div style={{ flex: 0.2, position: "absolute", width: "100%", top: 150 }}>
        <AnimatedIcon
          image={require("../../images/material-icon/blueBuzz.png")}
          animate={animate2}
          setAnimate={setAnimate2}
          timer={5500}
          timerInSecs={"5.5s"}
        />
      </div>
      <div style={{ flex: 0.2, position: "absolute", width: "100%", top: 300 }}>
        <AnimatedIcon
          image={require("../../images/icons/notificationBlue.png")}
          animate={animate3}
          setAnimate={setAnimate3}
          timer={7500}
          timerInSecs={"7.5s"}
        />
      </div>
      <div style={{ flex: 0.2, position: "absolute", width: "100%", top: 450 }}>
        <AnimatedIcon
          image={require("../../images/material-icon/blueBee.png")}
          animate={animate4}
          setAnimate={setAnimate4}
          timer={4500}
          timerInSecs={"4.5s"}
        />
      </div>
      <div style={{ flex: 0.2, position: "absolute", width: "100%", top: 600 }}>
        <AnimatedIcon
          image={require("../../images/material-icon/blueVehicle.png")}
          animate={animate5}
          setAnimate={setAnimate5}
          timer={6500}
          timerInSecs={"6.5s"}
        />
      </div>
      <div style={{ flex: 0.2, position: "absolute", width: "100%", top: 750 }}>
        <AnimatedIcon
          image={require("../../images/material-icon/blueOffence.png")}
          animate={animate6}
          setAnimate={setAnimate6}
          timer={9500}
          timerInSecs={"9.5s"}
        />
      </div> */}
      <LoadingPopUp display={loading} />
      <ToastNotification
        display={toastPop}
        title={popUpTitle}
        mainTitle={popUpTitle}
        message={message}
        width={width}
      />
    </div>
  );
};

export default AgencyDisplay;
